import { useContext, useEffect, useState } from "react";
import Container from "../../../components/components-ui/Container/Container";
import { Grid, Col } from "../../../components/Grid";
import { Formik, Form, Field } from "formik";
import Button from "../../../components/components-ui/Button/Button";
import styles from "./ordemcarregamento.module.css";
import "./Relatorios/RelatorioFreguesia/Print.css";
import DataTable from "react-data-table-component";
import {
  customStyles,
  SelectSearch,
} from "../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import * as Yup from "yup";
import { Box } from "@mui/material";
import { Table } from "../../../components/Table";
import api from "../../../services/Api";
import { toast } from "react-toastify";

import Modal from "@mui/material/Modal";
import CriarRota from "./ModalCriarRota/ModalCriarRota";
import Loading from "../../../components/components-ui/Loading/Loading";
import * as Sentry from "@sentry/react";
import { useVerificaPermissao } from "../../../utils/verificaPermissao";
import { AuthContext } from "../../../Provider/AuthContext";
import RelatorioFreguesia from "./Relatorios/RelatorioFreguesia/RelatorioFreguesia";

const columns = [
  {
    column: "Código",
  },
  {
    column: "Marca",
  },
  {
    column: "Logradouro",
  },
  {
    column: "Bairro",
  },
  {
    column: "Cidade",
  },
  {
    column: "Última Coleta",
  },
  {
    column: "Prioridade",
  },
  {
    column: "Média",
  },
  {
    column: "Coletas",
  },
];

const API_MARCA = "/freguesia/listalocalfreguesia?nome_local=";

function CriacaoRotaLogistica() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [dadosFreguesia, setDadosFreguesia] = useState([]);
  const [marca, setMarca] = useState([]);
  const [tipoFreguesia, setTipoFreguesia] = useState(null);
  const [freguesia, setFreguesia] = useState("");
  const [diaDaSemana, setDiaDaSemana] = useState("");
  const [next, setNext] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [inputMarca, setInputMarca] = useState("");
  const [loading, setLoading] = useState(false);
  const [tempName, setTempName] = useState("");

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela Relatorio da Freguesia
    verificaPermissao(idTipoUsuario, 47);
  }, []);

  const getMarca = async (input) => {
    setLoading(true);
    await api
      .get(API_MARCA + input)
      .then((res) => {
        setMarca(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  //Buscar locais ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputMarca.length) {
        getMarca(inputMarca);
      } else {
        setMarca([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputMarca]);

  const gerafreguesia = async (values, resetForm) => {
    await api
      .get(
        `/freguesia/gerafreguesia?freguesia=${values?.freguesia}&diadasemana=${values?.diaDaSemana}`
      )
      .then((res) => {
        if (res.data.data.length) {
          setTipoFreguesia(0);
          setDadosFreguesia(res.data.data);
          setFreguesia(values?.freguesia);
          setDiaDaSemana(values?.diaDaSemana);
          setTempName(res.data.temp_name);
          setNext(true);
          resetForm();
        } else {
          toast.warn(res.data.msg);
        }
      })
      .catch((error) => {
        toast.error("Algo de errado aconteceu ao buscar a freguesia. " + error);
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: `/freguesia/gerafreguesia?freguesia=${values?.freguesia}&diadasemana=${values?.diaDaSemana}`,
            payload: {
              freguesia: values?.freguesia,
              diaDaSemana: values?.diaDaSemana,
            },
          },
        });
      });
  };

  const gerafreguesiaAvulsa = async (resetForm) => {
    await api
      .get(
        `/freguesia/gerafreguesia?freguesia=${null}&diadasemana=${null}&idlocal=${null}`
      )
      .then((res) => {
        if (res.data) {
          setTipoFreguesia(1);
          setDadosFreguesia(res.data.data);
          setFreguesia(null);
          setDiaDaSemana(null);
          setTempName(res.data.temp_name);
          setNext(true);
          resetForm();
        } else {
          toast.warn(res.data.msg);
        }
      })
      .catch((error) => {
        toast.error("Algo de errado aconteceu ao buscar a freguesia. " + error);
      });
  };

  const back = () => {
    setDadosFreguesia([]);
    setFreguesia("");
    setDiaDaSemana("");
    setTipoFreguesia(null);
    setNext(false);
  };

  const onOpenModalCriarRota = () => {
    if (!dadosFreguesia.length)
      return toast.warn(
        "É necessário ter pelo menos um local para criar a rota!"
      );
    setOpenModal(true);
  };

  const adicionaFornecedor = async (idLocal, setFieldValue) => {
    if (!idLocal) return toast.warn("Selecione um local", { autoClose: 2000 });
    await api
      .get(
        `/freguesia/addlocalfreguesia?freguesia=${
          freguesia ?? null
        }&diadasemana=${diaDaSemana ?? null}&idlocal=${idLocal}`
      )
      .then((res) => {
        setDadosFreguesia([...res.data.data]);
        setTempName(res.data.temp_name);
        toast.success("Local adicionado com sucesso", { autoClose: 2000 });
        setFieldValue("marca", null);
      })
      .catch((error) => {
        toast.error(
          "Algo de errado aconteceu ao adicionar o novo local. " + error
        );
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: `/freguesia/addlocalfreguesia?freguesia=${freguesia}&diadasemana=${diaDaSemana}&idlocal=${idLocal}`,
            payload: { freguesia, diaDaSemana, idLocal },
          },
        });
      });
  };

  // const handleChangeMarca = async (selectedOption, setFieldValue) => {
  //   setFieldValue("marca", selectedOption ? selectedOption.value : null); // Setar valor do select
  // };

  const validationSchema = Yup.object().shape({
    freguesia: Yup.string()
      // .matches(/^[a-zA-Z0-9]*$/, "Somente letras e números são permitidos")
      .required("Insira a freguesia"),
    diaDaSemana: Yup.string()
      // .matches(/^[a-zA-Z0-9]*$/, "Somente letras e números são permitidos")
      .required("Insira o dia"),
  });

  return (
    <Container>
      <div className={styles.filter_header}>
        <h3>
          {!next
            ? "Relatório da Freguesia"
            : `Criação de Roteiro Freguesia ${
                freguesia ? freguesia + " Dia " + diaDaSemana : "Avulsa"
              }`}
        </h3>

        {next && (
          <Button
            type="button"
            className={styles.button_sm}
            onClick={() => back()}
          >
            <div>
              <i
                class="fas fa-chevron-left"
                style={{ color: "white", marginRight: "8px" }}
              ></i>
              <span style={{ color: "white" }}>Voltar</span>
            </div>
          </Button>
        )}
      </div>

      <div className={styles.container_grid}>
        <Box border={1} padding={1} marginY={1}>
          <Formik
            initialValues={{
              freguesia: "",
              diaDaSemana: "",
              marca: null,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) =>
              gerafreguesia(values, resetForm)
            }
          >
            {({
              errors,
              touched,
              values,
              setFieldValue,
              isSubmitting,
              resetForm,
            }) => (
              <Form>
                <section className={styles.filter_container}>
                  <strong>Filtros</strong>
                  {!next ? (
                    <Grid justifyContent={"space-between"} alignItems={"start"}>
                      <div className={styles.inputs_container}>
                        <Col size={1}>
                          <label>Freguesia</label>
                          <Field type="text" name="freguesia" maxLength={4} />
                          {errors.freguesia && touched.freguesia ? (
                            <span className={styles.alertError}>
                              {errors.freguesia}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={1}>
                          <label style={{ whiteSpace: "nowrap" }}>
                            Dia da Semana
                          </label>
                          <Field
                            type="text"
                            name="diaDaSemana"
                            maxLength={10}
                          />
                          {errors.diaDaSemana && touched.diaDaSemana ? (
                            <span className={styles.alertError}>
                              {errors.diaDaSemana}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label>&nbsp;</label>
                          <Button
                            type="submit"
                            disabled={isSubmitting}
                            // className={styles.button}
                            className={styles.button_lg}
                          >
                            <i
                              class="fas fa-check"
                              style={{ color: "white" }}
                            ></i>
                            Criar Freguesia
                          </Button>
                        </Col>
                      </div>
                      <Col size={2}>
                        <label>&nbsp;</label>
                        <Button
                          type="button"
                          onClick={() => gerafreguesiaAvulsa(resetForm)}
                          disabled={isSubmitting}
                          className={styles.button_lg}
                        >
                          <i
                            class="fas fa-truck-pickup"
                            style={{ color: "white", marginRight: "10px" }}
                          ></i>
                          Freguesia Avulsa
                        </Button>
                      </Col>
                    </Grid>
                  ) : (
                    <Grid className={styles.buttons_container}>
                      <Col size={4} style={{ alignSelf: "end" }}>
                        <label>Marca</label>
                        <Field name="marca">
                          {({ ...field }) => (
                            <Select
                              {...field}
                              value={values.marca}
                              options={marca.map((values) => ({
                                label: values?.NomeLocal,
                                value: values?.IdLocal,
                              }))}
                              styles={customStyles}
                              placeholder="Digite..."
                              noOptionsMessage={() =>
                                loading
                                  ? "Carregando..."
                                  : inputMarca.length
                                  ? "Nenhuma opção encontrada"
                                  : "Digite parte do nome"
                              }
                              onChange={(selectedOption) =>
                                setFieldValue("marca", selectedOption)
                              }
                              onInputChange={(e) => setInputMarca(e)}
                              isClearable
                            />
                          )}
                        </Field>
                        {errors.marca && touched.marca ? (
                          <span className={styles.alertError}>
                            {errors.marca}
                          </span>
                        ) : null}
                      </Col>
                      <div className={styles.buttons_container}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Button
                            type="button"
                            className={styles.button_lg}
                            onClick={() =>
                              adicionaFornecedor(
                                values?.marca?.value,
                                setFieldValue
                              )
                            }
                          >
                            <i
                              class="fas fa-plus"
                              style={{ color: "white" }}
                            ></i>
                            Adicionar <br /> Fornecedor
                          </Button>
                        </div>
                        {next ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              height: "100%",
                            }}
                          >
                            <Button
                              title="Criar Freguesia"
                              onClick={() => onOpenModalCriarRota()}
                              type="button"
                            />
                            <Button
                              onClick={() => window.print()}
                              className={styles.button_lg}
                              type="button"
                            >
                              <i
                                class="fas fa-print"
                                style={{ color: "white", marginRight: "10px" }}
                              ></i>
                              Imprimir <br /> Rel. Freguesia
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </Grid>
                  )}
                </section>
                <Loading display={isSubmitting ? "block" : "none"} />
              </Form>
            )}
          </Formik>
        </Box>

        {next ? (
          <Table columns={columns}>
            {dadosFreguesia.map((values) => (
              <tr key={values?.id_local}>
                <td>{values?.Codigo}</td>
                <td style={{ textAlign: "left" }}>{values?.Marca}</td>
                <td style={{ textAlign: "left" }}>{values?.Logradouro}</td>
                <td style={{ textAlign: "left" }}>{values?.Bairro}</td>
                <td style={{ textAlign: "left" }}>{values?.Cidade}</td>
                <td>{values?.DataEntrada}</td>
                <td>{values?.Prioridade}</td>
                <td>{values?.Media}</td>
                <td>{values?.ListagemDeColetas}</td>
              </tr>
            ))}
          </Table>
        ) : null}
      </div>
      <div id="relatorio">
        <RelatorioFreguesia
          freguesia={freguesia ?? "Avulsa"}
          dia={diaDaSemana}
          table={dadosFreguesia}
        />
      </div>
      <Modal
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CriarRota
          tipoFreguesia={tipoFreguesia}
          freguesia={freguesia}
          tempName={tempName}
          back={back}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </Container>
  );
}

export default CriacaoRotaLogistica;
